import common from "../rocketFactory/common.json";

const sources = {
  common,
};

export default sources;
